<h2 mat-dialog-title>{{ data.title }}</h2>

<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <mat-dialog-content>
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Description</mat-label>
      <input matInput formControlName="description" required />
    </mat-form-field>

    <!-- OTHER -->
    <ng-container *ngIf="data.item.itemType === 'OTHER'">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Price Per Unit</mat-label>
        <input matInput type="number" formControlName="pricePerUnit" required />
      </mat-form-field>
    </ng-container>

    <!-- COPPER -->
    <ng-container *ngIf="data.item.itemType === 'COPPER'">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Lbs Per 1000ft</mat-label>
        <input matInput type="number" formControlName="lbPer1000ft" required />
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Price Per Lb</mat-label>
        <input matInput type="number" formControlName="pricePerLb" required />
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Base Price</mat-label>
        <input matInput type="number" formControlName="basePrice" readonly />
      </mat-form-field>
    </ng-container>

    <!-- SINGLE_END -->
    <ng-container *ngIf="data.item.itemType === 'SINGLE_END'">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Specific Gravity</mat-label>
        <input matInput type="number" formControlName="specificGravity" required />
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Constant 1</mat-label>
        <input matInput type="number" formControlName="constant1" required />
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Price Per Lb</mat-label>
        <input matInput type="number" formControlName="pricePerLb" required />
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Base Price</mat-label>
        <input matInput type="number" formControlName="basePrice" readonly />
      </mat-form-field>
    </ng-container>

    <!-- COMPOUNDS and TEFLON_TAPES -->
    <ng-container
      *ngIf="data.item.itemType === 'COMPOUNDS' || data.item.itemType === 'TEFLON_TAPES'"
    >
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Specific Gravity</mat-label>
        <input matInput type="number" formControlName="specificGravity" required />
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Price Per Lb</mat-label>
        <input matInput type="number" formControlName="pricePerLb" required />
      </mat-form-field>
    </ng-container>

    <!-- ALL_TAPES_AND_FILLERS -->
    <ng-container *ngIf="data.item.itemType === 'ALL_TAPES_AND_FILLERS'">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Specific Gravity</mat-label>
        <input matInput type="number" formControlName="specificGravity" required />
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Constant 1</mat-label>
        <input matInput type="number" formControlName="constant1" required />
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Constant 2</mat-label>
        <input matInput type="number" formControlName="constant2" required />
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Price Per Lb</mat-label>
        <input matInput type="number" formControlName="pricePerLb" required />
      </mat-form-field>
    </ng-container>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-flat-button type="button" (click)="onCancel()">Cancel</button>
    <button mat-flat-button color="primary" type="submit" [disabled]="!form.valid">Save</button>
  </mat-dialog-actions>
</form>
